module.exports = __webpack_public_path__ + "static/img/xjMerchant.489e2d2e.png";